import {NgModule} from '@angular/core';
import {AuthGuard} from '../auth.guard';
import {RouterModule, Routes} from '@angular/router';
import {IntroComponent} from '../intro/intro.component';
import {LoanInfoComponent} from '../loan-info/loan-info.component';
import {LoanApplicationResolver} from './loan-application.resolver';
import {LoanDebtInfoGuard} from '../residence-info/loan-debt-info.guard';
import {PanBackLinkResolver} from '../pan-verification/pan-back-link.resolver';
import {LoanApplicationFlowComponent} from './loan-application-flow.component';
import {PersonalInfoComponent} from '../personal-info/personal-info.component';
import {PanInformationResolver} from '../pan-verification/pan-information.resolver';
import {ChannelPartnerIdResolver} from '../borrow/home/channel-partner-id.resolver';
import {ChannelPartnerLogoResolver} from '../borrow/home/channel-partner-logo.resolver';
import {LoanResidenceInfoResolver} from '../residence-info/loan-residence-info.resolver';
import {LoanApplicationFlowGuard} from '../application-flow/loan-application-flow.guard';
import {ResidenceInfoLinksResolver} from '../residence-info/residence-info-links.resolver';
import {PhoneVerificationComponent} from '../phoneverification/phone-verification.component';
import {LoanApplicationPanVerificationComponent} from '../pan-verification/pan-verification.component';
import {ApplicationFlowType, ResidenceInfoComponent} from '../residence-info/residence-info.component';
import {LoanApplicationEmailVerificationComponent} from '../email-verification/email-verification.component';
import {LivelihoodInformationComponent} from '../livelihood-information/livelihood-information.component';
import {BorrowedInfoComponent} from '../borrowed-info/borrowed-info.component';
import {ResidenceProofComponent} from '../residence-proof/residence-proof.component';
import {BorrowerBankDetailsComponent} from '../borrower-bank-details/borrower-bank-details.component';
import {BankAccountResolver} from '../borrower-bank-details/bank-account.resolver';
import {UploadDocumentsComponent} from '../upload-documents/upload-documents.component';
import {UploadDocumentsResolver} from '../upload-documents/upload-documents.resolver';
import {BorrowerSummaryComponent} from '../borrow/summary/borrower-summary.component';
import {BorrowerSummaryResolver} from '../borrow/summary/borrower-summary.resolver';
import {ResidenceProofResolver} from '../residence-proof/residence-proof.resolver';
import {SelectedOptionResolver} from "../borrow/eligibility-check/selected-option.resolver";
import {CreditAssessmentInfoResolver} from "../borrow/eligibility-check/credit-assessment-info.resolver";
import {ObligationsResolver} from "../resolvers/obligations.resolver";
import {IncomeResolver} from "../resolvers/income.resolver";

const routes: Routes = [{
    path: '',
    component: LoanApplicationFlowComponent,
    canActivateChild: [LoanApplicationFlowGuard],
    resolve: {
        partnerLogoUrl: ChannelPartnerLogoResolver
    },
    children: [{
        path: 'intro',
        component: IntroComponent,
        resolve: {
            channelPartnerInformation: ChannelPartnerIdResolver
        }
    }, {
        path: 'loan-info',
        component: LoanInfoComponent,
        resolve: {
            loanApplication: LoanApplicationResolver,
            selectedOption: SelectedOptionResolver
        }
    }, {
        path: 'pan-verification',
        component: LoanApplicationPanVerificationComponent,
        resolve: {
            panInformation: PanInformationResolver,
            backLink: PanBackLinkResolver
        }
    }, {
        path: 'phone-verification',
        component: PhoneVerificationComponent,
    }, {
        path: 'email-verification',
        component: LoanApplicationEmailVerificationComponent,
    }, {
        path: 'personal-info',
        component: PersonalInfoComponent,
        resolve: {
            creditAssessment: CreditAssessmentInfoResolver
        }
    }, {
        path: 'residence-info',
        component: ResidenceInfoComponent,
        data: {
            applicationFlowType: ApplicationFlowType.LoanApplicationFlow
        },
        resolve: {
            residenceInformation: LoanResidenceInfoResolver,
            links: ResidenceInfoLinksResolver
        },
        canActivate: [AuthGuard, LoanDebtInfoGuard]
    }, {
        path: 'livelihood-information',
        component: LivelihoodInformationComponent,
        resolve: {
            income: IncomeResolver,
        }
    }, {
        path: 'borrowed-info',
        component: BorrowedInfoComponent,
        resolve: {
            obligations: ObligationsResolver,
        }
    }, {
        path: 'residence-proof',
        component: ResidenceProofComponent,
        resolve: {
            residenceInformation: ResidenceProofResolver
        }
    }, {
        path: 'bank-details',
        component: BorrowerBankDetailsComponent,
        resolve: {
            bankAccount: BankAccountResolver
        }
    }, {
        path: 'upload-documents',
        component: UploadDocumentsComponent,
        resolve: {
            uploadDocumentsData: UploadDocumentsResolver
        }
    }, {
        path: 'summary',
        component: BorrowerSummaryComponent,
        resolve: {
            summary: BorrowerSummaryResolver
        }
    }]
}];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)]
})
export class LoanApplicationFlowRoutingModule {
}
